import React from "react";
import { Box, Fab, Tooltip, Typography } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import ChipFilter from "../../../../components/filters/ChipFilter";
import SingleDatePicker from "../../../../components/filters/SingleDatePicker";
import styles from "./ExportUnitExclusionsFilters.styles";

export default function ExportUnitExclusionsFilters({
  filters,
  setFilters,
  dateFilter,
  setDateFilter,
  unitOptions = [],
  operatorOptions = [],
  onExport,
}) {
  const toggleFilter = (type, value) => {
    setFilters((prev) => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter((item) => item !== value)
        : [...current, value];

      return { ...prev, [type]: updated };
    });
  };

  const clearFilter = (type) => {
    setFilters((prev) => ({ ...prev, [type]: [] }));
  };

  return (
    <Box sx={styles.filterRow}>
      <Box sx={styles.filterLeft}>
        <Typography sx={styles.label}>Filters:</Typography>

        <ChipFilter
          label="Unit"
          type="unit"
          values={unitOptions}
          selectedValues={filters.unit || []}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <ChipFilter
          label="Operator"
          type="operator"
          values={operatorOptions}
          selectedValues={filters.operator || []}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <SingleDatePicker date={dateFilter} setDate={setDateFilter} />
      </Box>

      <Box sx={styles.rightControls}>
        <Tooltip title="Export to CSV" arrow>
          <Fab size="small" sx={styles.fabButton} onClick={onExport}>
            <FileDownloadIcon fontSize="small" />
          </Fab>
        </Tooltip>
      </Box>
    </Box>
  );
}
